import { assert } from '@sama/js-core';
import { forEach, isNil } from '@sama/micro-dash';
import {
  isOutputWithAnswerOptions,
  isSensorFusionOutput,
} from '../../../cross-team-shared/misc-utils/output-utils';
import {
  AbstractOutput,
  AbstractOutputWithAnswerOptions,
} from '../../../team-apis/otterdam/outputs/output';
import { AnswerOptionFilter, NestedOutputFilter } from './fusion-state';
import { TaskWorkspaceStore } from './task-workspace-store';

export function getPrimaryOutputId(output: AbstractOutput) {
  if (isSensorFusionOutput(output)) {
    const fusedOutputs = output.meta.fused_outputs;
    const primary = fusedOutputs.find((fusedOutput) => fusedOutput.primary);
    assert(primary, 'Sensor fusion should have a primary output');
    return primary.output_id;
  }
  return output.id;
}

export function initShapeFilterStore(
  taskWorkspaceStore: TaskWorkspaceStore,
  output: AbstractOutputWithAnswerOptions,
) {
  const fusedAnserOptionFilters: NestedOutputFilter[] = output.answer_options
    .filter((i) => !i.dynamic)
    .map((i) => ({
      outputName: i.name,
      outputLabel: i.label?.replace(/^#/, '') || i.name,
      namesAndLabels: getAnswerOptionsNamesAndLabels(
        taskWorkspaceStore,
        i.name,
      ),
    }))
    .filter((value) => value.namesAndLabels.length !== 0);

  const fusionStore = taskWorkspaceStore('fusions')(output.id);
  forEach(fusedAnserOptionFilters, (nestedOutputFilter) => {
    // @ts-ignore -- fix me
    fusionStore('nestedOutputFilter')(nestedOutputFilter.outputName).set(
      // @ts-ignore -- fix me
      nestedOutputFilter,
    );
  });
}

function getAnswerOptionsNamesAndLabels(
  taskWorkspaceStore: TaskWorkspaceStore,
  name: string,
): AnswerOptionFilter[] {
  const output = taskWorkspaceStore
    .state()
    .project.outputs.find((o) => o.name === name);

  if (isNil(output) || !isOutputWithAnswerOptions(output)) {
    return [];
  }
  return [
    {
      name: 'none',
      label: 'No Label',
      filterOut: false,
    },
  ].concat(
    output.answer_options.map((i) => ({
      name: i.name,
      label: i.label || i.name,
      filterOut: false,
    })),
  );
}

export function buildInspectModeKey(projectId: number) {
  return `projectSettings:${projectId}:inspectMode`;
}
